export default {
  init() {
    $('[data-fancybox]').fancybox();

    jQuery('img.svg').each(function(){
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if(typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if(typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass+' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, else we gonna set it if we can.
        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        // Replace image with new SVG
        $img.replaceWith($svg);
      }, 'xml');
    });

    $('.slider-single').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
    });

    $('.swiper-wrap').each(function (index, sliderWrap) {
      var $swiper = $(sliderWrap).find('.swiper-four');
      var $prev = $(sliderWrap).find('.prev');
      var $next = $(sliderWrap).find('.next');
      $swiper.slick({
        autoplay: true,
        dots: false,
        centerMode: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        autoplaySpeed: 8000,
        prevArrow: $prev,
        nextArrow: $next,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],  
      });
    });

    $('.slide-four').slick({
      autoplay: true,
      dots: false,
      centerMode: false,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.swiper-antes-depois').each(function (index, slider) {
      var $swiper = $(slider).find('.slide-antes-depois');
      var $prev = $(slider).find('.prev');
      var $next = $(slider).find('.next');
      $swiper.slick({
        autoplay: true,
        dots: false,
        centerMode: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        autoplaySpeed: 8000,
        prevArrow: $prev,
        nextArrow: $next,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],  
      });
    });
  
    document.querySelectorAll('.bt-link').forEach(button => {
      button.addEventListener('click', function() {
        const content = this.previousElementSibling;
    
        if (content.classList.contains('expanded')) {
          content.classList.remove('expanded');
          this.textContent = 'Continuar lendo';
        } else {
          // Recolher todas as outras divs
          document.querySelectorAll('.content-body.expanded').forEach(expandedContent => {
            expandedContent.classList.remove('expanded');
            expandedContent.nextElementSibling.textContent = 'Continuar lendo';
          });
          
          // Expandir a div clicada
          content.classList.add('expanded');
          this.textContent = 'Ler menos';
        }
      });
    });
    
  },
  finalize() {
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js